/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {Typography} from "design_system/src";
import useCurrentCity from "hooks/useCurrentCity";
import { fetchRecommendedVehicles } from "store/actions/recommended";
import { RootState } from "store";
import VehicleCardPlaceHolder from "components/placeholders/vehicleCardPlaceHolder/VehicleCardPlaceHolder";
import CardVehicle from "components/cards/CardVehicle";

interface RecommendedDetailsProps {
  model: string;
}

const RecommendedDetails: React.FC<RecommendedDetailsProps> = ({ model }) => {
  const dispatch = useDispatch();
  const city = useCurrentCity();

  const {
    data: vehicles,
    loading: recommendedLoading,
    error: recommendedError,
  } = useSelector((state: RootState) => state.recommendedReducer);

  useEffect(() => {
    dispatch(fetchRecommendedVehicles({ model, city, limit: 4 }));
  }, [city]);

  return (
    <div className="m_y_xl">
      <div className="div-title m_t_xxxl m_b_md">
        <Typography scale="large" weight="600" className="p_b_sm">
          Motocicletas
          <span className="text_primary_300">
                {" "}
            similares
              </span>
        </Typography>
      </div>
      <Grid container direction="row" spacing={3}>
        {!recommendedLoading && !recommendedError && vehicles ? (
          vehicles.map((vehicle,idx) => (
            <Grid key={`recommended-${vehicle.internalId}`} item xs={12} md={3}>
              {vehicle.images[0] && (
                <CardVehicle key={idx} vehicle={vehicle} isHelperCard={false} />
              )}
            </Grid>
          ))
        ) : recommendedLoading ? (
          <>
            {_.range(24).map((_, index) => (
              <Grid
                key={`recommended-${index}`}
                xs={6}
                md={3}
                container
                justifyContent="center"
                item
              >
                <VehicleCardPlaceHolder />
              </Grid>
            ))}
          </>
        ) : (
          "Se produjo un error vuelva a cargar la pagina"
        )}
        {!recommendedLoading &&
          !recommendedError &&
          vehicles &&
          vehicles?.length < 1 &&
          "No se encontraron recomendaciones"}
      </Grid>
    </div>
  );
};

export default RecommendedDetails;
